import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../services/api";
import "./UserProfilePage.css"; // reuse the same styles

const BusinessUserProfilePage = () => {
  const [bu, setBu] = useState({ first_name: "", last_name: "" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBuProfile = async () => {
      try {
        const { data } = await api.get("/bu/profile"); // protected by authenticateBusinessToken
        setBu(data || {});
      } catch (err) {
        console.error("Error fetching business user profile:", err);
        setError("Failed to fetch profile. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchBuProfile();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="user-pro-error">{error}</p>;

  return (
    <div className="user-pro-container">
      <h2 className="user-pro-heading">Welcome, {bu.first_name}!</h2>

      <div className="user-pro-card">
        <ul className="user-pro-list">
          <li>
            <Link to="/bu/user/edit" className="user-pro-link">✏️ Edit Profile</Link>
          </li>
          <li>
            <Link to="/faqs" className="user-pro-link">📖 FAQs</Link>
          </li>
          <li>
            <Link to="/support" className="user-pro-link">🛠️ Support & Requests</Link>
          </li>
          {/* Add more BU-relevant links as needed */}
        </ul>
      </div>
    </div>
  );
};

export default BusinessUserProfilePage;
